<template>
	<view class="success">
		<view class="icon">
			<image src="/pagesA/static/ic_paysuccess@2x.png" mode="widthFix"></image>
		</view>
		<view class="info">
			<text>提交成功</text>
			<text>请耐心等待平台审核</text>
		</view>
		<view class="btns">
			<view class="btns-a" @click="jumpShopIndex()">返回</view>
			<view class="btns-b"  @click="jumpDetail()">查看详情</view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				id:null
			};
		},
		onLoad(options){
			this.id = options.id
		},
		methods:{
			jumpDetail(){
				uni.redirectTo({
					url: '/pagesA/pages/withdrawal-details/withdrawal-details?id='+this.id
				})
			},
			jumpShopIndex(){
				uni.navigateBack({
					delta:1
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.success {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding-top: 200rpx;
		box-sizing: border-box;
		.icon {
			width: 180rpx;
			height: 180rpx;
			image {
				width: 100%;
			}
		}
		.info {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin-top: 32rpx;
			text {
				&:nth-child(2) {
					font-weight: 500;
					font-size: 36rpx;
					color: #222222;
				}
				&:nth-child(2) {
					font-weight: 400;
					font-size: 26rpx;
					color: #999999;
					margin-top: 20rpx;
				}
			}
		}
		.btns {
			display: flex;
			align-items: center;
			margin-top: 76rpx;
			.btns-a {
				width: 200rpx;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				font-weight: 400;
				font-size: 28rpx;
				color: #666666;
				margin-right: 24rpx;
				border-radius: 36rpx;
				border: 1rpx solid rgba(153,153,153,0.5);
			}
			.btns-b {
				width: 200rpx;
				height: 72rpx;
				line-height: 72rpx;
				text-align: center;
				border-radius: 36rpx;
				font-weight: 400;
				font-size: 28rpx;
				color: #004096;
				border: 1rpx solid #004096;
			}
		}
	}
</style>